import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import { ref, reactive, onMounted, onBeforeUnmount, onUpdated } from "vue";
import ResponseData from "@/types/ResponseData";
import { useI18n } from "vue3-i18n";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import PermisApprovalDataService from "@/services/PermissionApprovalDataService";
import { store } from "@/store/store";
import SendEmailService from "@/services/SendEmailService";
import UserInfoDataService from "@/services/UserInfoDataService";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref("Menu Approval");

const permisInfo = reactive([]);
const isNoData = ref(false);
const approveStatus = ref("3");
const denyStatus = ref("4");
const modalSubject = ref("");
const modalBody = ref("");
const buttonText = ref("");
const selectedCondition =ref("1");

const rowUserData = reactive([]);
const rowUserPermission = reactive([]);
const rowStatus = ref("");

/** 初期表示設定 */
onMounted(function () {
  window.addEventListener('resize', handleResize);
  isLoading.value = true;
  alertMessage.value = "null";
  alertState.value = "neutral";
  getPermissionInfo();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("tblPermistbody")?.clientHeight;
    if (dataHeight != 0) {
      tableHeight = document.getElementById("tblPermisdiv")?.clientHeight;
      if (dataHeight > tableHeight) {
        document.getElementById("tblPermisdiv").style.width = "100%";
      } else {
        document.getElementById("tblPermisdiv").style.width =
          "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
}

const goSearchByCondition = () => {
  isLoading.value = true;
  alertMessage.value = "null";
  alertState.value = "neutral";
  getPermissionInfo();
}

const getPermissionInfo = () => {
  permisInfo.splice(0);
  isLoading.value = true;

  const data = {
    userId: store.getters.cognitoUserName,
    selectedCondition: selectedCondition.value
  };
  PermisApprovalDataService.getPermissionInfo(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        permisInfo.push(response.data);
        isNoData.value = false;
        isLoading.value = false;
      } else {
        isNoData.value = true;
        isLoading.value = false;
      }
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err043");
      alertState.value = "error";
      isLoading.value = false;
    });
};

const rowParam = (rowUserInfo,rowUserPermitInfo, clickStatus) => {
  rowUserData.push(rowUserInfo);
  rowUserPermission.push(rowUserPermitInfo);
  rowStatus.value = clickStatus;

  if (clickStatus == "3") {
    modalSubject.value = "Approve Permission";
    modalBody.value = i18n.t("cnf006");
    buttonText.value = "Approve";
  } else {
    modalSubject.value = "Deny Permission";
    modalBody.value = i18n.t("cnf007");
    buttonText.value = "Deny";
  }
};

const clearRowParam = () => {
  rowUserData.splice(0);
  rowUserPermission.splice(0);
};

const permisApproveDeny = () => {
  isLoading.value = true;
  alertMessage.value = "null";
  alertState.value = "neutral";

  const data = {
    userId: rowUserData[0].userId,
    mainMenuCode: rowUserPermission[0].mainMenuCode,
    clickStatus: rowStatus.value,
    loginUserId: store.getters.cognitoUserName,
    email: rowUserData[0].email,
    userName: rowUserData[0].givenName + " " + rowUserData[0].familyName,
    targetMailFormat: "mail_permission_denied",
    sendingPattern: "permission_denied",
    mainMenuName: rowUserPermission[0].mainMenuName,
    staionCode: rowUserData[0].stationCode
  };
  if(rowStatus.value == approveStatus.value){
    data.targetMailFormat = "mail_permission_approved";
    data.sendingPattern = "permission_approved";
  }
  PermisApprovalDataService.permisApproveDeny(data)
    .then((response: ResponseData) => {
      SendEmailService.sendEmail(data)
      .then((response2: ResponseData) => {
        if (rowStatus.value == approveStatus.value) {
          // AfterSalesの「Automobile、Motorcycle、Marine」Service
          var afterSales = ["MM0047","MM0048","MM0049"];
          if(afterSales.includes(rowUserPermission[0].mainMenuCode)){
            // ftirjの権限なのでユーザーにメール通知したくないため、actionFlgを5から6へ変更する
            const csvfileData1 = {
              actionFlg: 6,
              userID: rowUserData[0].userId,
              LName: rowUserData[0].familyName,
              FName: rowUserData[0].givenName,
              employeeID: rowUserData[0].employeeNumber,
              mail: rowUserData[0].email,
              companyName: rowUserData[0].companyName,
              stationCode: rowUserData[0].stationCode,
              appType: "AfterSales"
            };
            UserInfoDataService.send_authenticationID(csvfileData1)
            .then((response: ResponseData) => {
              alertMessage.value = i18n.t("suc006");
            })
            .catch((e: Error) => {
              alertMessage.value = i18n.t("err063");
              alertState.value = "error";
              isLoading.value = false;
            });
          } else {
            alertMessage.value = i18n.t("suc006");
          }

          // IT Environment Surveyを申請したとき、STで「SIVPssotest」、本番で「SIVPsso」を申請する
          if(rowUserPermission[0].mainMenuCode == 'MM0092'){
            const csvfileData1 = {
              actionFlg: 5,
              userID: rowUserData[0].userId,
              LName: rowUserData[0].familyName,
              FName: rowUserData[0].givenName,
              employeeID: rowUserData[0].employeeNumber,
              mail: rowUserData[0].email,
              companyName: rowUserData[0].companyName,
              stationCode: rowUserData[0].stationCode,
              appType: "ITEnvironmentSurvey"
            };
            UserInfoDataService.send_authenticationID(csvfileData1)
            .then((response: ResponseData) => {
              alertMessage.value = i18n.t("suc006");
            })
            .catch((e: Error) => {
              alertMessage.value = i18n.t("err063");
              alertState.value = "error";
              isLoading.value = false;
            });
          } else {
            alertMessage.value = i18n.t("suc006");
          }
        } else {
          alertMessage.value = i18n.t("suc007");
        }
        alertState.value = "success";
        getPermissionInfo();
        clearRowParam();
      })
      .catch((e: Error) => {
        alertMessage.value = "Failed to send notice email of permission approval/deny";
        alertState.value = "error";
        isLoading.value = false;
      });
    })
    .catch((e: Error) => {
      if (rowStatus.value == approveStatus.value) {
        alertMessage.value = i18n.t("err044");
      } else {
        alertMessage.value = i18n.t("err059");
      }
      alertState.value = "error";
      isLoading.value = false;
    });
};

const goToApprovalHistory = () => {
    store.dispatch("setShowPage","MenuApprovalHistory");
    store.dispatch("setShowPageTitle","Menu Approval History Inquiry");
}

onUpdated(function () {
  handleResize();
});

const __returned__ = { isLoading, alertMessage, alertState, i18n, title, permisInfo, isNoData, approveStatus, denyStatus, modalSubject, modalBody, buttonText, selectedCondition, rowUserData, rowUserPermission, rowStatus, handleResize, goSearchByCondition, getPermissionInfo, rowParam, clearRowParam, permisApproveDeny, goToApprovalHistory, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})